export class DocumentModel{
    id_type_doc_demat: String;
    lb_type_doc_demat: String;
    b_docclient: boolean;
    b_docuser: boolean;

    constructor(id_type: String, type: String, docDemat: boolean, docAImprimer: boolean){
        this.id_type_doc_demat = id_type;
        this.lb_type_doc_demat = type;
        this.b_docclient = docDemat;
        this.b_docuser = docAImprimer;
    }
}